import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { _hide_award_modal } from '../../store/Action';
import { Modal } from 'antd';
import Util from '../../script/util';
import './AwardModal.scss';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { award_visible, awardData } = this.props.base;
    return (
      <Modal
        open={award_visible}
        wrapClassName="transparent-body"
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="900px"
        zIndex="1006"
        onCancel={_hide_award_modal}
      >
        <div className="award-bg">
          <div className="award-content">
            <div className="gift-content">
              {awardData.prizeList &&
                awardData.prizeList.map((citem, cindex) => {
                  return (
                    <div
                      key={`citem-${cindex}`}
                      className={
                        awardData.prizeList.length > 1
                          ? 'gift-item'
                          : 'all-count-1'
                      }
                    >
                      <div
                        className="cover"
                        style={{
                          backgroundImage: `url(${Util.transImgUrl(citem.img)})`,
                        }}
                      ></div>
                      <div className="info">
                        <span className="name">{citem.name}</span>
                        <span className="number">x{citem.number}</span>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="gift-msg-content">
              <p>{awardData.text}</p>
            </div>
            <span className="close-modal" onClick={_hide_award_modal}></span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
